<h1 class="titel">{{ "ScanYourMachine" | translate }}</h1>
<img
    src="https://www.poettinger.at/img/landtechnik/pages/20191107_mypoettinger_header_2000x1000_2019-10.jpg"
    alt="Header"
/>
<canvas #scanCanvas></canvas>
